import styled from 'styled-components'
import {Col, UnstyledButton} from '@modifi/ui'

export const ShipmentsEmptyState = styled(Col)`
  height: calc(100vh - 450px);
  min-height: 220px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;

  strong {
    display: block;
    margin-top: 24px;
  }
`
export const TooltipIconWrapper = styled(UnstyledButton)`
  margin-right: 16px;
`

export const NotificationCheckBoxContainer = styled(Col)`
  display: flex;
  justify-content: end;
`
